import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M11 8.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m9 1a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-7.163 7.683.055.277a.86.86 0 0 1-.337.864 8.59 8.59 0 0 1-10.11 0 .86.86 0 0 1-.337-.864l.055-.277A5.2 5.2 0 0 1 7.266 13h.468c2.48 0 4.616 1.75 5.103 4.183m2.016-.115-.055-.277a7.2 7.2 0 0 0-.814-2.17A4.27 4.27 0 0 1 17.333 13h.267c1.998 0 3.74 1.36 4.225 3.299l.066.265a.68.68 0 0 1-.25.706 6.77 6.77 0 0 1-6.765.79c.05-.324.044-.66-.023-.992"
    }
  )
);
var SvgPeopleFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PeopleFilled_default = SvgPeopleFilled;

export { PeopleFilled_default as default };
